module.exports = __webpack_public_path__ + "static/media/ic-ava-register.b3946543.svg";